module.exports = __webpack_public_path__ + "media/images/payments/neteller-3c91de23706fd97b70da1131b47ffd06.svg";